//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';

export interface ParamsType {
    id: number;
}

const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api/market/{id} -> get -> ${code}`);
    };
};

export const Response200IO = t.interface({
    result: t.union([
        t.null,
        t.undefined,
        t.interface({
            active: t.boolean,
            autoTakeDown: t.union([t.null, t.undefined, t.boolean]),
            betLimitsMap: t.union([
                t.null,
                t.undefined,
                t.interface({
                    inPlay: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            liabilityLimit: t.union([t.null, t.undefined, t.number]),
                            maxBet: t.union([t.null, t.undefined, t.number]),
                            maxMultipleBet: t.union([t.null, t.undefined, t.number]),
                            maxWin: t.union([t.null, t.undefined, t.number]),
                        }),
                    ]),
                    prematch: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            liabilityLimit: t.union([t.null, t.undefined, t.number]),
                            maxBet: t.union([t.null, t.undefined, t.number]),
                            maxMultipleBet: t.union([t.null, t.undefined, t.number]),
                            maxWin: t.union([t.null, t.undefined, t.number]),
                        }),
                    ]),
                    show: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            liabilityLimit: t.union([t.null, t.undefined, t.number]),
                            maxBet: t.union([t.null, t.undefined, t.number]),
                            maxMultipleBet: t.union([t.null, t.undefined, t.number]),
                            maxWin: t.union([t.null, t.undefined, t.number]),
                        }),
                    ]),
                }),
            ]),
            betReferralEnabled: t.union([t.null, t.undefined, t.boolean]),
            blockSettlement: t.union([t.null, t.undefined, t.boolean]),
            bp: t.boolean,
            bpApplicable: t.union([t.null, t.undefined, t.boolean]),
            cashoutAvailable: t.union([t.null, t.undefined, t.boolean]),
            cashoutMarketSettings: t.union([
                t.null,
                t.undefined,
                t.interface({
                    baseCashout: t.union([t.null, t.undefined, t.number]),
                    cashoutOfferEasing: t.union([t.null, t.undefined, t.number]),
                    cashoutOverround: t.union([t.null, t.undefined, t.number]),
                }),
            ]),
            display: t.union([t.null, t.undefined, t.boolean]),
            displayOrder: t.number,
            dividends: t.union([
                t.null,
                t.undefined,
                t.interface({
                    forecast: t.union([
                        t.null,
                        t.undefined,
                        t.array(
                            t.interface({
                                '2nd': t.number,
                                dividend: t.number,
                                id: t.number,
                                winner: t.number,
                            })
                        ),
                    ]),
                    tricast: t.union([
                        t.null,
                        t.undefined,
                        t.array(
                            t.interface({
                                '2nd': t.number,
                                '3rd': t.number,
                                dividend: t.number,
                                id: t.number,
                                winner: t.number,
                            })
                        ),
                    ]),
                }),
            ]),
            eachWay: t.union([
                t.null,
                t.undefined,
                t.interface({
                    offered: t.boolean,
                    terms: t.array(
                        t.interface({
                            places: t.number,
                            reduction: t.string,
                        })
                    ),
                    termsWithBet: t.boolean,
                }),
            ]),
            eachWayStakeReduction: t.union([t.null, t.undefined, t.number]),
            event: t.interface({
                id: t.number,
            }),
            eventId: t.number,
            feedSettings: t.union([
                t.null,
                t.undefined,
                t.interface({
                    eachWay: t.union([t.null, t.undefined, t.boolean]),
                    prices: t.union([t.null, t.undefined, t.boolean]),
                    results: t.union([t.null, t.undefined, t.boolean]),
                    updates: t.union([t.null, t.undefined, t.boolean]),
                }),
            ]),
            forecastsOffered: t.union([t.null, t.undefined, t.boolean]),
            id: t.number,
            idv2: t.string,
            inPlayDelay: t.union([t.null, t.undefined, t.number]),
            line: t.union([t.null, t.undefined, t.number]),
            name: t.string,
            platformMarketName: t.union([t.null, t.undefined, t.string]),
            revision: t.number,
            rule4: t.union([
                t.null,
                t.undefined,
                t.array(
                    t.interface({
                        deduction: t.union([t.null, t.undefined, t.number]),
                        endTime: t.union([t.null, t.undefined, t.string]),
                        id: t.number,
                        selection: t.union([t.null, t.undefined, t.number]),
                    })
                ),
            ]),
            selections: t.record(
                t.string,
                t.interface({
                    active: t.union([t.null, t.undefined, t.boolean]),
                    betLimits: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            liabilityLimit: t.union([t.null, t.undefined, t.number]),
                            maxBet: t.union([t.null, t.undefined, t.number]),
                            maxMultipleBet: t.union([t.null, t.undefined, t.number]),
                            maxWin: t.union([t.null, t.undefined, t.number]),
                        }),
                    ]),
                    display: t.union([t.null, t.undefined, t.boolean]),
                    displayOrder: t.union([t.null, t.undefined, t.number]),
                    feedSettings: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            eachWay: t.union([t.null, t.undefined, t.boolean]),
                            prices: t.union([t.null, t.undefined, t.boolean]),
                            results: t.union([t.null, t.undefined, t.boolean]),
                            updates: t.union([t.null, t.undefined, t.boolean]),
                        }),
                    ]),
                    id: t.number,
                    idv2: t.string,
                    name: t.union([t.null, t.undefined, t.string]),
                    platformObject: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            name: t.string,
                        }),
                    ]),
                    price: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            d: t.number,
                            f: t.string,
                        }),
                    ]),
                    priceHistory: t.union([
                        t.null,
                        t.undefined,
                        t.array(
                            t.interface({
                                p: t.interface({
                                    d: t.number,
                                    f: t.string,
                                }),
                                t: t.string,
                            })
                        ),
                    ]),
                    priceType: t.union([t.null, t.undefined, t.string]),
                    result: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            isDraft: t.union([t.null, t.undefined, t.boolean]),
                            place: t.union([t.null, t.undefined, t.number]),
                            placeReductions: t.union([
                                t.null,
                                t.undefined,
                                t.array(
                                    t.interface({
                                        eachWayTerms: t.interface({
                                            places: t.number,
                                            reduction: t.string,
                                        }),
                                        placeReduction: t.union([t.null, t.undefined, t.string]),
                                    })
                                ),
                            ]),
                            type: t.union([t.null, t.undefined, t.string]),
                            winReduction: t.union([t.null, t.undefined, t.string]),
                        }),
                    ]),
                    selectionSettings: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            defaultSpPrice: t.union([t.null, t.undefined, t.string]),
                        }),
                    ]),
                    spPrice: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            d: t.number,
                            f: t.string,
                        }),
                    ]),
                    state: t.union([t.null, t.undefined, t.string]),
                    tags: t.record(t.string, t.string),
                    template: t.union([
                        t.null,
                        t.undefined,
                        t.interface({
                            id: t.string,
                            marketTemplateId: t.string,
                        }),
                    ]),
                    uuid: t.union([t.null, t.undefined, t.string]),
                })
            ),
            singlesOnly: t.union([t.null, t.undefined, t.boolean]),
            sp: t.boolean,
            spApplicable: t.union([t.null, t.undefined, t.boolean]),
            spOnly: t.boolean,
            state: t.string,
            suspendTime: t.union([t.null, t.undefined, t.string]),
            tags: t.record(t.string, t.string),
            template: t.interface({
                id: t.string,
                marketTemplateType: t.string,
                name: t.string,
            }),
            tradedInPlay: t.boolean,
            tricastsOffered: t.union([t.null, t.undefined, t.boolean]),
            updated: t.interface({
                updatedAt: t.string,
            }),
            updatedInMs: t.number,
            uuid: t.union([t.null, t.undefined, t.string]),
        }),
    ]),
});
export type Response200Type = {
    result?:
        | null
        | undefined
        | {
              active: boolean;
              autoTakeDown?: null | undefined | boolean;
              betLimitsMap?:
                  | null
                  | undefined
                  | {
                        inPlay?:
                            | null
                            | undefined
                            | {
                                  liabilityLimit?: null | undefined | number;
                                  maxBet?: null | undefined | number;
                                  maxMultipleBet?: null | undefined | number;
                                  maxWin?: null | undefined | number;
                              };
                        prematch?:
                            | null
                            | undefined
                            | {
                                  liabilityLimit?: null | undefined | number;
                                  maxBet?: null | undefined | number;
                                  maxMultipleBet?: null | undefined | number;
                                  maxWin?: null | undefined | number;
                              };
                        show?:
                            | null
                            | undefined
                            | {
                                  liabilityLimit?: null | undefined | number;
                                  maxBet?: null | undefined | number;
                                  maxMultipleBet?: null | undefined | number;
                                  maxWin?: null | undefined | number;
                              };
                    };
              betReferralEnabled?: null | undefined | boolean;
              blockSettlement?: null | undefined | boolean;
              bp: boolean;
              bpApplicable?: null | undefined | boolean;
              cashoutAvailable?: null | undefined | boolean;
              cashoutMarketSettings?:
                  | null
                  | undefined
                  | {
                        baseCashout?: null | undefined | number;
                        cashoutOfferEasing?: null | undefined | number;
                        cashoutOverround?: null | undefined | number;
                    };
              display?: null | undefined | boolean;
              displayOrder: number;
              dividends?:
                  | null
                  | undefined
                  | {
                        forecast?:
                            | null
                            | undefined
                            | Array<{
                                  '2nd': number;
                                  dividend: number;
                                  id: number;
                                  winner: number;
                              }>;
                        tricast?:
                            | null
                            | undefined
                            | Array<{
                                  '2nd': number;
                                  '3rd': number;
                                  dividend: number;
                                  id: number;
                                  winner: number;
                              }>;
                    };
              eachWay?:
                  | null
                  | undefined
                  | {
                        offered: boolean;
                        terms: Array<{
                            places: number;
                            reduction: string;
                        }>;
                        termsWithBet: boolean;
                    };
              eachWayStakeReduction?: null | undefined | number;
              event: {
                  id: number;
              };
              eventId: number;
              feedSettings?:
                  | null
                  | undefined
                  | {
                        eachWay?: null | undefined | boolean;
                        prices?: null | undefined | boolean;
                        results?: null | undefined | boolean;
                        updates?: null | undefined | boolean;
                    };
              forecastsOffered?: null | undefined | boolean;
              id: number;
              idv2: string;
              inPlayDelay?: null | undefined | number;
              line?: null | undefined | number;
              name: string;
              platformMarketName?: null | undefined | string;
              revision: number;
              rule4?:
                  | null
                  | undefined
                  | Array<{
                        deduction?: null | undefined | number;
                        endTime?: null | undefined | string;
                        id: number;
                        selection?: null | undefined | number;
                    }>;
              selections: Record<
                  string,
                  {
                      active?: null | undefined | boolean;
                      betLimits?:
                          | null
                          | undefined
                          | {
                                liabilityLimit?: null | undefined | number;
                                maxBet?: null | undefined | number;
                                maxMultipleBet?: null | undefined | number;
                                maxWin?: null | undefined | number;
                            };
                      display?: null | undefined | boolean;
                      displayOrder?: null | undefined | number;
                      feedSettings?:
                          | null
                          | undefined
                          | {
                                eachWay?: null | undefined | boolean;
                                prices?: null | undefined | boolean;
                                results?: null | undefined | boolean;
                                updates?: null | undefined | boolean;
                            };
                      id: number;
                      idv2: string;
                      name?: null | undefined | string;
                      platformObject?:
                          | null
                          | undefined
                          | {
                                name: string;
                            };
                      price?:
                          | null
                          | undefined
                          | {
                                d: number;
                                f: string;
                            };
                      priceHistory?:
                          | null
                          | undefined
                          | Array<{
                                p: {
                                    d: number;
                                    f: string;
                                };
                                t: string;
                            }>;
                      priceType?: null | undefined | string;
                      result?:
                          | null
                          | undefined
                          | {
                                isDraft?: null | undefined | boolean;
                                place?: null | undefined | number;
                                placeReductions?:
                                    | null
                                    | undefined
                                    | Array<{
                                          eachWayTerms: {
                                              places: number;
                                              reduction: string;
                                          };
                                          placeReduction?: null | undefined | string;
                                      }>;
                                type?: null | undefined | string;
                                winReduction?: null | undefined | string;
                            };
                      selectionSettings?:
                          | null
                          | undefined
                          | {
                                defaultSpPrice?: null | undefined | string;
                            };
                      spPrice?:
                          | null
                          | undefined
                          | {
                                d: number;
                                f: string;
                            };
                      state?: null | undefined | string;
                      tags: Record<string, string>;
                      template?:
                          | null
                          | undefined
                          | {
                                id: string;
                                marketTemplateId: string;
                            };
                      uuid?: null | undefined | string;
                  }
              >;
              singlesOnly?: null | undefined | boolean;
              sp: boolean;
              spApplicable?: null | undefined | boolean;
              spOnly: boolean;
              state: string;
              suspendTime?: null | undefined | string;
              tags: Record<string, string>;
              template: {
                  id: string;
                  marketTemplateType: string;
                  name: string;
              };
              tradedInPlay: boolean;
              tricastsOffered?: null | undefined | boolean;
              updated: {
                  updatedAt: string;
              };
              updatedInMs: number;
              uuid?: null | undefined | string;
          };
};
export const decodeResponse200 = createGuard(200, Response200IO);

type ExtraHeadersType = Record<string, string>;

/**
 * @deprecated - Please use this method "openapiSocketGetMarketRequest"
 */
export const openapi_socket_get_market = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<FetchGeneralRawResponseType> => {
    const query = '';
    const url = `${api_url}/api/market/${params.id}${query}`;

    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};

export type OpenapiSocketGetMarketParamsType = ParamsType;

export type OpenapiSocketGetMarketResponseType = {
    status: 200;
    body: Response200Type;
};

export type OpenapiSocketGetMarketResponse200Type = Response200Type;

export const openapiSocketGetMarketRequest = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<OpenapiSocketGetMarketResponseType> => {
    const response = await openapi_socket_get_market(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    throw new Error(`openapiSocketGetMarketRequest - unhandled response ${response.status}`);
};
